import { ActivityTracking } from '@telstra-connect/billing';
import { secureRouteBuilder } from '../secure-route';
import PaymentDetails from '@applications/billing/pages/payment-details/index-lazy';
import AdjustmentDetails from '@applications/billing/pages/adjustment-details/index-lazy';
import RepaymentDetails from '@applications/billing/pages/repayment-details/index-lazy';
import UsageDetails from '@applications/billing/pages/usage-details/index-lazy';
import OrderDetails from '@applications/billing/pages/order-details/index-lazy';
import InvoiceDetailUpdatedStructure from '@applications/billing/pages/invoice-details-updated-structure/index-lazy';
import InvoiceDetailsLegacy from '@applications/billing/pages/invoice-details-legacy-single-view/index-lazy';
import InvoiceDetailsStrategic from '@applications/billing/pages/invoice-details-strategic-able/index-lazy';
import EnquiryDetailsActivity from '@applications/billing/pages/enquiry-detail-activity/index-lazy';
import DiscountDetails from './pages/discount-details/index-lazy';
import FeaturePackDetailsLatest from '@applications/billing/pages/feature-pack-details-with-accordion/index-lazy';
// tslint:disable-next-line: max-line-length
import NewEnquiryPageLatestUI from '@applications/billing/pages/new-enquiry-latest-ui/index-lazy';
import TAnalystErrorScreen from '@applications/billing/pages/T-analyst-error-screen/index-lazy';
import DirectDebitServiceAgreement from '@applications/billing/pages/direct-debit-service-agreement/index-lazy';
import RecurringChargeDetails from '@applications/billing/pages/recurring-details/index-lazy';
import EnquiryResult from '@applications/billing/pages/new-enquiry-latest-ui/components/enquiry-redirect-component/index-lazy';
import BillingCard from '@applications/billing/components/dashboard-billing-card/index-lazy';
import AddPaymentMethodSuccessComponent from '@applications/billing/pages/add-payment-method/component/add-payment-method-success/index-lazy';
import Routes from './route-constants';
import { Activity } from '@utils/activity-tracking';
import { IApplicationDefinition, IAppRegistry, IRenderRouteOptions } from '@apps-config/app-definition';
import { ApplicationsFlags } from '@telstra-connect/subscriptions/state/config-subscriptions';
import { RoutesHelper } from '@apps-config/routing/routing';
import SummaryHOC from '@applications/billing/pages/summary-hoc-component/index-lazy';
import Home from '@applications/billing/pages/home/index-lazy';
import PaymentOption from '@applications/billing/pages/payment-option/index-lazy';
import SetupDirectDebit from '@applications/billing/pages/setup-direct-debit/index-lazy';
import AddNewPaymentMethod from '@applications/billing/pages/add-payment-method/index-lazy';
import UpdateDirectDebit from '@applications/billing/pages/update-direct-debit/index-lazy';
import PayByCreditCard from '@applications/billing/pages/payby-credit-card/index-lazy';
import ErrorPageUnsuccessfulCancelDDComponent from '@applications/billing/pages/cancel-direct-debit-unsuccessful-page/index-lazy';
import PayByCreditCardSuccessComponent from '@applications/billing/pages/payby-credit-card/component/pay-by-credit-card-success/index-lazy';
import { ShowAddPaymentMethods } from './pages/show-add-payment-method';
import global from '@applications/global';
import { isInternationalCustomer } from '@telstra-connect/config/config';
import { SuccessPageDirectDebit } from './pages/payment-method-page-able/components/success-page-direct-debit';
import { ErrorPageDirectDebit } from './pages/payment-method-page-able/components/error-page-direct-debit';

const routes = new RoutesHelper({
    rootPath: secureRouteBuilder(Routes.Billing),
    subpagesPathMask: secureRouteBuilder(Routes.Billing)
});

declare const window: {
    applications: ApplicationsFlags
}
const applicationName = ActivityTracking.ApplicationName;
const menuItemName = 'Billing';
const tracker = Activity.createTracker(applicationName);

export const Application: IApplicationDefinition = {
    get applicationName() {
        return applicationName;
    },

    get acceptsUserFeedback() {
        return true;
    },

    get acceptsErrorReports() {
        return true;
    },

    get card() {
        return BillingCard;
    },

    get tracker() {
        return tracker;
    },

    get routes() {
        return routes;
    },

    init(registry: IAppRegistry, availableToUser: boolean) {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        const flags = window.applications && window.applications[`Billing`];
        if (availableToUser && flags && flags.application) {
            registry.add(Application);
        }
    },

    render() {
        // tslint:disable-next-line:no-string-literal
        // tslint:disable-next-line:no-string-literal
        const invoiceStrategicAble = global.applications.Billing.InvoiceStrategicAble || false
        const billingRoutes = [
            // Line Item Routes
            {
                path: routes.getPageSubpath(Routes.NewEnquiryRoute),
                component: NewEnquiryPageLatestUI
            },
            {
                path: routes.getPageSubpath(Routes.InvoiceDetailsRoute),
                component: invoiceStrategicAble ? InvoiceDetailsStrategic : InvoiceDetailUpdatedStructure
            },
            {
                path: routes.getPageSubpath(Routes.InvoiceDetailsRouteLegacy),
                component: InvoiceDetailsLegacy
            },
            {
                path: routes.getPageSubpath(Routes.GetEnquiryDetailsRoute),
                component: EnquiryDetailsActivity
            },
            {
                path: routes.getPageSubpath(Routes.PaymentDetailsRoute),
                component: PaymentDetails
            },
            {
                path: routes.getPageSubpath(Routes.SummaryRoute),
                component: SummaryHOC
            },
            {
                path: routes.getPageSubpath(Routes.Home),
                component: Home,
            },
            {
                path: routes.getPageSubpath(Routes.AdjustmentDetailsRoute),
                component: AdjustmentDetails
            },
            {
                path: routes.getPageSubpath(Routes.RepaymentDetailsRoute),
                component: RepaymentDetails
            },
            {
                path: routes.getPageSubpath(Routes.RepaymentDetailsRouteNew),
                component: RepaymentDetails
            },
            {
                path: routes.getPageSubpath(Routes.GetUsageDetailsRoute),
                component: UsageDetails
            },
            {
                path: routes.getPageSubpath(Routes.OrderDetailsRoute),
                component: OrderDetails
            },
            {
                path: routes.getPageSubpath(Routes.OrderDetailsRouteNew),
                component: OrderDetails
            },
            {
                path: routes.getPageSubpath(Routes.DiscountDetailsRoute),
                component: DiscountDetails
            },
            {
                path: routes.getPageSubpath(Routes.DiscountDetailsRouteNew),
                component: DiscountDetails
            },
            {
                path: routes.getPageSubpath(Routes.EnquirySubmittedRoute),
                component: EnquiryResult
            },
            {
                path: routes.getPageSubpath(Routes.FeaturePackDetailsRoute),
                component: FeaturePackDetailsLatest
            },
            {
                path: routes.getPageSubpath(Routes.FeaturePackDetailsRouteNew),
                component: FeaturePackDetailsLatest
            },
            {
                path: routes.getPageSubpath(Routes.RecurringChargeDetailsRoute),
                component: RecurringChargeDetails
            },
            {
                path: routes.getPageSubpath(Routes.RecurringChargeDetailsNewRoute),
                component: RecurringChargeDetails
            },
            {
                path: routes.getPageSubpath(Routes.InvoiceSummaryOlderRoute),
                component: SummaryHOC
            },
            {
                path: routes.getPageSubpath(Routes.PaymentOption),
                component: PaymentOption
            },
            {
                path: routes.getPageSubpath(Routes.PaymentMethods),
                component: PaymentOption
            },
            {
                path: routes.getPageSubpath(Routes.SetupDirectDebit),
                component: SetupDirectDebit
            },
            {
                path: routes.getPageSubpath(Routes.GetTAnalystError),
                component: TAnalystErrorScreen
            },
            {
                path: routes.getPageSubpath(Routes.GetDirectDebitServiceAgreementRoute),
                component: DirectDebitServiceAgreement
            },
            {
                path: routes.getPageSubpath(Routes.UpdateDirectDebit),
                component: UpdateDirectDebit
            },
            {
                path: routes.getPageSubpath(Routes.UnsuccessfulCancelRoute),
                component: ErrorPageUnsuccessfulCancelDDComponent
            },
            {
                path: routes.getPageSubpath(Routes.PayByCreditCard),
                component: PayByCreditCard
            },
            {
                path: routes.getPageSubpath(Routes.PayByCreditCardSuccess),
                component: PayByCreditCardSuccessComponent
            },
            {
                path: routes.getPageSubpath(Routes.SavedPaymentMethods),
                component: ShowAddPaymentMethods
            },
            {
                path: routes.getPageSubpath(Routes.AddNewPaymentMethods),
                component: AddNewPaymentMethod
            },
            {   path: routes.getPageSubpath(Routes.AddPaymentMethodSuccess),
                component: AddPaymentMethodSuccessComponent
            },
            {   path: routes.getPageSubpath(Routes.directDebitSuccess),
                component: SuccessPageDirectDebit
            },
            {   path: routes.getPageSubpath(Routes.directDebitError),
                component: ErrorPageDirectDebit
            },
        ];

        return billingRoutes as unknown as IRenderRouteOptions[];
    },

    menuItem<IBillingAppState>(state) {
        let isInternational = false;
        if (state?.billing?.cidnList?.data?.length) {
            isInternational = isInternationalCustomer(state?.billing?.cidnList?.data[0].value)
        }
        const showHomePageFlag = global.applications.Billing.TEDT36263ShowHomePageAble && !isInternational;
        const showIntHomePage = global.applications.Billing.IntBillingPageAbleFeature && isInternational;

        const pagePath = showHomePageFlag ?  Application.routes.getPageSubpath(
            Routes.Home
        ) :  showIntHomePage ? Application.routes.getPageSubpath(Routes.Home) : Application.routes.getPageSubpath(
            Routes.InvoiceSummaryRoute
        );

        return [
            {
                testID: 'ui-menu-billing',
                name: menuItemName,
                intialPagePath: pagePath,
                appPath: routes.getAppPath(),
                onClick: () => {
                    Application.tracker.trackMenu(menuItemName);
                }
            }
        ];
    }
};
